import apiClient from './client'
import type {
  BroadcastRequest,
  BroadcastResponse,
  NotificationListResponse,
  NotificationMessageOut,
  TemplateInfo,
  TemplatePreviewResponse,
  UnreadCountResponse,
} from '@/types/api'

export const notificationsApi = {
  list(params?: { unread_only?: boolean; limit?: number; offset?: number }) {
    return apiClient.get<NotificationListResponse>('/notifications', { params })
  },

  unreadCount() {
    return apiClient.get<UnreadCountResponse>('/notifications/unread-count')
  },

  markRead(id: number) {
    return apiClient.post<NotificationMessageOut>(`/notifications/${id}/read`)
  },

  markAllRead() {
    return apiClient.post<{ updated: number }>('/notifications/read-all')
  },

  remove(id: number) {
    return apiClient.delete<void>(`/notifications/${id}`)
  },

  // ---- 超管专属 ----
  broadcast(body: BroadcastRequest) {
    return apiClient.post<BroadcastResponse>('/admin/notifications/broadcast', body)
  },

  listTemplates() {
    return apiClient.get<TemplateInfo[]>('/admin/notification-templates')
  },

  renderTemplatePreview(
    type: string,
    params?: { task_id?: number; pre_order_id?: number; order_id?: number },
  ) {
    return apiClient.get<TemplatePreviewResponse>(
      `/admin/notification-templates/${type}/preview`,
      { params },
    )
  },
}